import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'src/app/core/services/message.service';
import { ModalPdfComponent } from '../modal-pdf/modal-pdf.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-receipt-merchandise',
  templateUrl: './receipt-merchandise.component.html',
  styleUrls: ['./receipt-merchandise.component.scss']
})
export class ReceiptMerchandiseComponent implements OnInit {
  form: FormGroup;
  tipoBulto: string;
  submitted: boolean;
  myData: any[];
  phase: string;

  constructor(private formBuilder: FormBuilder, private messageService: MessageService, public dialog: MatDialog) { }

  ngOnInit() {
    this.myData = ['', 0, '', ''];
    this.tipoBulto = 'Cartones';
    this.phase = 'saving';

    this.setMyValidators();
  }

  setMyValidators() {
    this.form = this.formBuilder.group({
      cliente: ['', Validators.required],
      bultos: ['', [Validators.required, Validators.min(1)]],
      proveedor: ['', Validators.required],
      tipobulto: ['', Validators.required],
      linea: ['', Validators.required]
    });
  }

  get controls() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;

    if(this.phase == 'saved') {
      this.setMyValidators();
      this.controls.tipobulto.setValue('Cartones');
      this.controls.bultos.setValue(0);
      this.phase = 'saving';
    }

    if (this.form.invalid) {
      // this.messageService.error('Error', '*Campos Obligatorios*');
      return;
    } else {
      this.submitted = false;
      this.phase = 'saved';
      this.CleanMyData();
      this.openDialog();
      this.messageService.success('Éxito', 'Mercancía recibida correctamente');
    }
  }

  CleanMyData() {
    this.controls.cliente.clearValidators();
    this.controls.bultos.clearValidators();
    this.controls.proveedor.clearValidators();
    this.controls.linea.clearValidators();
    this.form.reset({});
    this.controls.tipobulto.setValue('Cartones');
    this.controls.bultos.setValue(0);
  }

  private openDialog(): void {
    const dialogRef = this.dialog.open(ModalPdfComponent, {
        height: '600px',
        width: '600px',
        data: { title: 'Recibo de mercancía', url: '/assets/pdf/ReciboMercancia.pdf' }
    });

    dialogRef.afterClosed().subscribe(() => {
      // this.messageService.success('Éxito', 'Las fotografías se han guardado correctamente');
    });
  }

}
